import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NGXLogger } from "ngx-logger";
import { enqCategory, enqCategoryDetails } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})

export class EnquiryRegService {

  public EnqCategories: Array<enqCategory>;

  constructor(private http: HttpService, private logger: NGXLogger) { }

  public getAllCategories(): Observable<Array<enqCategory>> {
    return this.http.getFromApi('/EnquiryReg/GetCategories');
  }

  public GetCategoryDetails(categoryId: number): Observable<Array<enqCategoryDetails>> {
    return this.http.getFromApi(`/EnquiryReg/GetCategoryDetails?categoryId=${categoryId}`);
  }

  public checkCategoryForDialer(categoryId: number): Observable<Array<any>> {
    return this.http.getFromApi(`/EnquiryReg/CheckCategoryForDialer?categoryId=${categoryId}`);
  }

  public checkSelectedForQueue(categoryId: number): Observable<Array<any>> {
    return this.http.getFromApi(`/EnquiryReg/CheckSelectedForQueue?categoryId=${categoryId}`);
  }

  public deleteCategory(categoryIds: number[]): Observable<boolean> {
    let body = JSON.stringify(categoryIds);
    return this.http.postToApi(`/EnquiryReg/DeleteCategory`, body);
  }

  public updateCategory(category: any): Observable<boolean> {
    let body = JSON.stringify(category);
    return this.http.postToApi(`/EnquiryReg/UpdateCategory`, body);
  }

  public updateCategoriesOrder(categories: any[]): Observable<boolean> {
    let body = JSON.stringify(categories);
    return this.http.postToApi(`/EnquiryReg/UpdateCategoriesOrder`, body);
  }

  public createCategory(category: any): Observable<number> {
    let body = JSON.stringify(category);
    return this.http.postToApi(`/EnquiryReg/CreateCategory`, body);
  }

  public createSubCategory(category: any): Observable<number> {
    let body = JSON.stringify(category);
    return this.http.postToApi(`/EnquiryReg/CreateSubCategory`, body);
  }
}  